var map = {
	"./AI Legal Document Automation Platform/1.png": 2611,
	"./AI Legal Document Automation Platform/2.png": 2206,
	"./AI Padel Refree Platform/1.png": 8608,
	"./AI Padel Refree Platform/2.png": 3648,
	"./AI Padel Refree Platform/3.png": 193,
	"./AI Padel Refree Platform/4.png": 4410,
	"./CDOL - Subscription Based DB Web Application/1.JPG": 3063,
	"./CDOL - Subscription Based DB Web Application/2.JPG": 1051,
	"./CDOL - Subscription Based DB Web Application/3.JPG": 9298,
	"./CDOL - Subscription Based DB Web Application/4.JPG": 5359,
	"./CDOL - Subscription Based DB Web Application/5.JPG": 7535,
	"./CDOL - Subscription Based DB Web Application/6.JPG": 316,
	"./Caltalogs thousnads of Amazon products every minute (Built from scratch)/1.png": 9762,
	"./Caltalogs thousnads of Amazon products every minute (Built from scratch)/2.png": 9162,
	"./Caltalogs thousnads of Amazon products every minute (Built from scratch)/3.png": 5365,
	"./HostEvents Analytics Platform/1.png": 142,
	"./HostEvents Analytics Platform/2.png": 204,
	"./HostEvents Analytics Platform/3.png": 9231,
	"./Launch Control/1.png": 9696,
	"./Launch Control/CRM-like lis view where sales agents can view all prospects.png": 1657,
	"./Launch Control/selecting a prospect a detailed view opens to send text message.png": 7976,
	"./Multi-agent AI System with n8n  Voice, OCR, Calendar, Contacts, Quiz/1.png": 5498,
	"./Multi-agent AI System with n8n  Voice, OCR, Calendar, Contacts, Quiz/2.png": 5357,
	"./Multi-agent AI System with n8n  Voice, OCR, Calendar, Contacts, Quiz/3.png": 4706,
	"./Multi-agent AI System with n8n  Voice, OCR, Calendar, Contacts, Quiz/4.png": 4019,
	"./Multi-agent AI System with n8n  Voice, OCR, Calendar, Contacts, Quiz/5.png": 7700,
	"./Multi-agent AI System with n8n  Voice, OCR, Calendar, Contacts, Quiz/6.png": 3529,
	"./Multi-agent AI System with n8n  Voice, OCR, Calendar, Contacts, Quiz/7.png": 6874,
	"./Music Generator/1.png": 1720,
	"./Music Generator/2.png": 4428,
	"./Music Generator/3.png": 8701,
	"./Music Generator/4.png": 7902,
	"./Music Generator/5.png": 1978,
	"./Music Generator/6.png": 9698,
	"./Music Generator/7.png": 3743,
	"./New folder/1.png": 3699,
	"./New folder/2.png": 5471,
	"./New folder/3.png": 7410,
	"./New folder/4.png": 7052,
	"./OSINT SaaS/1.png": 4572,
	"./OSINT SaaS/2.png": 968,
	"./OSINT SaaS/3.png": 1491,
	"./OSINT SaaS/4.png": 6702,
	"./OSINT SaaS/5.png": 6172,
	"./Toronto Neibourhood Analysis/1.png": 486,
	"./Toronto Neibourhood Analysis/2.png": 3115,
	"./Toronto Neibourhood Analysis/3.png": 7788,
	"./Toronto Neibourhood Analysis/4.png": 8227,
	"./iDENTIFY/1.png": 7050,
	"./iDENTIFY/2.png": 262
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8984;